export class LatLng {
  lat: number;
  lng: number;

  constructor(lat: number, lng: number) {
    this.lat = lat;
    this.lng = lng;
  }

  distanceTo(other: LatLng): number {
    const R = 6371000; // Earth's radius in meters
    const dLat = (other.lat - this.lat) * Math.PI / 180;
    const dLng = (other.lng - this.lng) * Math.PI / 180;
    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(this.lat * Math.PI / 180) * Math.cos(other.lat * Math.PI / 180) *
      Math.sin(dLng / 2) * Math.sin(dLng / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c;
  }

  equals(other: LatLng): boolean {
    return this.lat === other.lat && this.lng === other.lng;
  }
}

export class LatLngBounds {
  private _southWest: LatLng;
  private _northEast: LatLng;

  constructor(southWest: LatLng | [number, number], northEast: LatLng | [number, number]) {
    if (Array.isArray(southWest)) {
      this._southWest = new LatLng(southWest[0], southWest[1]);
    } else {
      this._southWest = southWest;
    }
    if (Array.isArray(northEast)) {
      this._northEast = new LatLng(northEast[0], northEast[1]);
    } else {
      this._northEast = northEast;
    }
  }

  getSouthWest(): LatLng { return this._southWest; }
  getNorthEast(): LatLng { return this._northEast; }
  getNorth(): number { return this._northEast.lat; }
  getSouth(): number { return this._southWest.lat; }
  getEast(): number { return this._northEast.lng; }
  getWest(): number { return this._southWest.lng; }

  getCenter(): LatLng {
    return new LatLng(
      (this._southWest.lat + this._northEast.lat) / 2,
      (this._southWest.lng + this._northEast.lng) / 2
    );
  }

  contains(latlng: LatLng | LatLngBounds): boolean {
    if (latlng instanceof LatLngBounds) {
      return this.contains(latlng.getSouthWest()) && this.contains(latlng.getNorthEast());
    }
    return latlng.lat >= this._southWest.lat &&
           latlng.lat <= this._northEast.lat &&
           latlng.lng >= this._southWest.lng &&
           latlng.lng <= this._northEast.lng;
  }

  extend(latlng: LatLng): LatLngBounds {
    this._southWest = new LatLng(
      Math.min(this._southWest.lat, latlng.lat),
      Math.min(this._southWest.lng, latlng.lng)
    );
    this._northEast = new LatLng(
      Math.max(this._northEast.lat, latlng.lat),
      Math.max(this._northEast.lng, latlng.lng)
    );
    return this;
  }
}
